<label [ngClass]="styles.RadioContainer" #wrapperLabel [attr.tabindex]="disableTabFocus ? -1 : 0" vbKeypress (enterKeyPressed)="onChangeInternal()">
	<input type="radio" [checked]="!!checked" [attr.aria-checked]="!!checked" [attr.aria-label]="accessibilityLabel" [attr.name]="name" [attr.value]="optionValue" (change)="onChangeInternal($event)" tabindex="-1">
	<span [ngClass]="[
			styles.vbRadioCheckmark,
			checked ? 'theme-accent theme-accent-font-border' : ''
		]">
		<span class="theme-accent-inverted" [ngClass]="styles.vbRadioCheckmarkChecked" [hidden]="!checked">
		</span>
	</span>

	<span [ngClass]="styles.vbRadioTextInput">
		<ng-content></ng-content>
	</span>
</label>
